import React from 'react';
import { Link } from 'react-router-dom';
import { strings } from '/imports/strings';
import { Page } from '/imports/ui/Page';
import { PageHeading } from '/imports/ui/PageHeading';
import { PageBody } from '/imports/ui/PageBody';
import { useFindOne, useUser } from '/imports/hooks';
import { Icon } from '/imports/ui/Icon';
import { Accounts, Roles } from '/imports/api/accounts';

const ManagePageStyled = (props: React.ComponentProps<typeof Page>) => (
  <Page
    {...props}
    className={[
      props.className ?? '',
      '[&_.onboarding-banner]:mx-[-1rem] [&_.onboarding-banner]:flex [&_.onboarding-banner]:h-16 [&_.onboarding-banner]:items-center [&_.onboarding-banner]:justify-center [&_.onboarding-banner]:gap-6 [&_.onboarding-banner]:bg-red-6 [&_.onboarding-banner]:font-bold [&_.onboarding-banner]:text-red-7 [&_.onboarding-banner]:underline',
      '[&_.onboarding-banner_span]:cursor-pointer',
    ].join(' ')}
  />
);

export const ManagePage = () => {
  const user = useUser();
  const userId = user?._id;
  const orgId = user?.orgId;
  const account = useFindOne(() => Accounts.find({orgId, userId}), [`${orgId}_${userId}`]);
  return (
    <ManagePageStyled>
      <PageHeading
        left={<h1>{strings.Manage()}</h1>}
      />
      <PageBody>
        <div className="items">
          <ManageItem title={strings.Profile()} subtitle={strings.NameEmailPassword()} icon="accountCircle" to="/profile" />
          {/* <ManageItem title={strings.Integrations()} subtitle={strings.ThirdPartyConnections()} icon="hub" to="/integrations" /> */}
          {
            user?.isSuperUser || account?.roles?.includes(Roles.admin) ?
              <ManageItem title={strings.Accounts()} subtitle={strings.AddOrModifyAccountsInYourOrg()} icon="idCard" to="/accounts" /> : null
          }
          {
            user?.isSuperUser ?
              <>
                <ManageItem title={strings.Users()} subtitle="" icon="person" to="/users" />
                <ManageItem title={strings.Organizations()} subtitle="" icon="group" to="/orgs" />
                
                <ManageItem title={strings.Settings()} subtitle="" icon="settings" to="/settings" />
                <ManageItem title={strings.Environment()} subtitle="" icon="dns" to="/environment" />
                <ManageItem title={strings.DevTools()} subtitle="" icon="construction" to="/devtools" />
              </>
              :
              null
          }
        </div>
        <div className="logout my-4 text-center [&_span]:cursor-pointer">
          <Link to="/logout">{strings.Logout()}</Link>
        </div>
      </PageBody>
    </ManagePageStyled>
  );
};

interface ManageItemProps {
  title: string;
  subtitle: string;
  icon: string;
  to: string;
}

const ManageItem = (props: ManageItemProps) => (
  <Link
    to={props.to}
    className="mx-[-1rem] flex w-[calc(100%+2rem)] border-t border-grey-6 py-3 last:border-b last:border-grey-6"
  >
    <div className="item-icon inline-flex w-16 items-center justify-center [&_svg]:h-7 [&_svg]:w-7 text-primary"><Icon icon={props.icon as any} /></div>
    <div className="details flex-1 [&_.title]:font-bold">
      <div className="title">{props.title}</div>
      <div>{props.subtitle}</div>
    </div>
    <div className="item-icon inline-flex w-16 items-center justify-center [&_svg]:h-7 [&_svg]:w-7 text-primary"><Icon icon="chevronRight" /></div>
  </Link>
);